import { useCallback, useMemo } from 'react';
import { useInsertTextToEditor } from './useInsertTextToEditor';
import {
  ArtifactV3_Output,
  isArtifactCode,
  isArtifactMarkdown,
} from 'src/types';
import { useCodeEditorActions } from './useCodeEditorActions';
import { getLanguageKey } from 'src/utils';

export const useInsertStreamableContentToEditor = () => {
  const { replaceTextWithArtifact } = useInsertTextToEditor();
  const { setCodeEditorData } = useCodeEditorActions();

  const onInsertStreamableContent = useCallback(
    (artifactOutput?: ArtifactV3_Output) => {
      if (!artifactOutput?.contents || artifactOutput.contents.length === 0) {
        return;
      }

      const currentArtifact =
        artifactOutput.contents[artifactOutput?.contents?.length - 1];

      if (isArtifactMarkdown(currentArtifact)) {
        replaceTextWithArtifact(currentArtifact);
      }

      if (isArtifactCode(currentArtifact)) {
        const { code, language } = currentArtifact;
        setCodeEditorData({
          content: code,
          language: getLanguageKey(language),
        });
      }
    },
    [replaceTextWithArtifact, setCodeEditorData],
  );

  return useMemo(
    () => ({ onInsertStreamableContent }),
    [onInsertStreamableContent],
  );
};
